import React from 'react';
import Card from 'react-bootstrap/Card';

import Header from './header';
import Pane from './pane';
import withNameInput from './hoc-input';
import withNameDatepicker from './hoc-datepicker';

const FundSize = withNameInput('fundSize', 'Fund Size');
const FundSizeDate = withNameDatepicker('fundSizeDate', 'Fund Size Date');

export default function FundNetAssets() {
  const event = 'netAssets';

  return (
    <Card>
      <Card.Header>
        <Header eventKey={event}>Fund Net Assets</Header>
      </Card.Header>
      <Pane eventKey={event}>
        <Card.Body>
          <FundSize />
          <FundSizeDate />
        </Card.Body>
      </Pane>
    </Card>
  );
}
